import { FEATURE_MESAS } from "../../config/features";
import { fmtCLP } from "../../utils/formato";
import "./OrderForm.css";

export default function OrderForm({
  cliente, setCliente,
  telefono, setTelefono,
  canal, setCanal,
  mesa, setMesa,
  horaRetiro, setHoraRetiro,
  medioPago, setMedioPago,
  trabajador = false, setTrabajador,
  dividirPago = false, setDividirPago,
  medioPago2 = "", setMedioPago2,
  montoPago1Raw = "", setMontoPago1Raw,
  pago1Pagado = false, setPago1Pagado,
  pago2Pagado = false, setPago2Pagado,
  totalFinal = 0,
  observacion, setObservacion,
  pagado, setPagado,
  mobileDetailsOpen, setMobileDetailsOpen,
  erroresForm = {},
}) {
  const monto1 = Math.max(0, Math.round(Number(String(montoPago1Raw).replace(/\./g, "").replace(",", ".")) || 0));
  const saldo = Math.max(0, Math.round(Number(totalFinal || 0)) - monto1);

  return (
    <div className="col-form pos-form-wrap">
      <div className="of-card">

        {/* ===== Sección: Datos del cliente ===== */}
        <div className="of-section">
          <div className="of-section__head">
            <div className="of-section__icon">👤</div>
            <h3 className="of-section__title">Datos del cliente</h3>
          </div>

          <div className="of-fields">
            <div className="of-row">
              <div className="of-field">
                <label>Nombre</label>
                <input
                  type="text"
                  value={cliente}
                  onChange={(e) => setCliente(e.target.value)}
                  placeholder="Ej: Juan Pérez"
                />
              </div>

              <div className="of-field">
                <label>Teléfono</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  maxLength={9}
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value.replace(/\D/g, "").slice(0, 9))}
                  placeholder="912345678"
                  title="Celular Chile: 9 dígitos"
                />
              </div>
            </div>

            <div className={`of-field ${erroresForm.canal ? "of-field--error" : ""}`}>
              <label>
                Canal <span className="of-required">*</span>
              </label>
              <div className="of-segmented">
                <div className="of-seg__option">
                  <input
                    type="radio"
                    id="canal-local"
                    name="canal"
                    value="Local"
                    checked={canal === "Local"}
                    onChange={(e) => setCanal(e.target.value)}
                  />
                  <label className="of-seg__label" htmlFor="canal-local">
                    🏠 Local
                  </label>
                </div>
                <div className="of-seg__option">
                  <input
                    type="radio"
                    id="canal-whatsapp"
                    name="canal"
                    value="WhatsApp"
                    checked={canal === "WhatsApp"}
                    onChange={(e) => setCanal(e.target.value)}
                  />
                  <label className="of-seg__label" htmlFor="canal-whatsapp">
                    💬 WhatsApp
                  </label>
                </div>
              </div>
              {erroresForm.canal && (
                <span className="of-field__error">Seleccioná el canal</span>
              )}
            </div>

            <div className="of-toggle-row of-toggle-row--worker">
              <span className="of-toggle-row__label">Trabajador</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={trabajador}
                  onChange={(e) => setTrabajador?.(e.target.checked)}
                />
                <span className="slider" />
              </label>
            </div>
          </div>
        </div>

        {/* ===== Botón expandir (solo mobile) ===== */}
        <button
          type="button"
          className="of-trigger"
          onClick={() => setMobileDetailsOpen((o) => !o)}
          aria-expanded={mobileDetailsOpen}
        >
          {mobileDetailsOpen ? "▲ Ocultar retiro y pago" : "▼ Retiro, pago y más"}
        </button>

        {/* ===== Sección: Retiro y Pago ===== */}
        <div className={`of-details ${mobileDetailsOpen ? "is-open" : ""}`}>
          <div className="of-section">
            <div className="of-section__head">
              <div className="of-section__icon">🛵</div>
              <h3 className="of-section__title">Retiro y pago</h3>
            </div>

            <div className="of-fields">
              {FEATURE_MESAS && (
                <div className="of-field">
                  <label>Mesa</label>
                  <input
                    type="text"
                    value={mesa}
                    onChange={(e) => setMesa(e.target.value)}
                    placeholder="Nº mesa"
                  />
                </div>
              )}

              <div className="of-row">
                <div className={`of-field ${erroresForm.horaRetiro ? "of-field--error" : ""}`}>
                  <label>
                    Hora de Retiro <span className="of-required">*</span>
                  </label>
                  <input
                    type="time"
                    value={horaRetiro}
                    onChange={(e) => setHoraRetiro(e.target.value)}
                  />
                  {erroresForm.horaRetiro && (
                    <span className="of-field__error">Ingresá la hora de retiro</span>
                  )}
                </div>

                <div className={`of-field ${erroresForm.medioPago ? "of-field--error" : ""}`}>
                  <label>
                    Medio de Pago {!trabajador && <span className="of-required">*</span>}
                  </label>
                  {trabajador ? (
                    <input type="text" value="No aplica" disabled readOnly />
                  ) : (
                    <select
                    value={medioPago}
                    onChange={(e) => {
                      const value = e.target.value;
                      setMedioPago(value);
                    }}
                  >
                    <option value="">Seleccionar…</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Tarjeta">Tarjeta</option>
                    </select>
                  )}
                  {erroresForm.medioPago && (
                    <span className="of-field__error">Seleccioná el medio de pago</span>
                  )}
                </div>
              </div>

              {!trabajador && <div className="of-toggle-row">
                <span className="of-toggle-row__label">Dividir en 2 medios</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={dividirPago}
                    onChange={(e) => {
                      setDividirPago?.(e.target.checked);
                      if (!e.target.checked) {
                        setMedioPago2?.("");
                        setMontoPago1Raw?.("");
                      }
                    }}
                  />
                  <span className="slider" />
                </label>
              </div>}

              {!trabajador && dividirPago && (
                <div className={`of-split-pay ${erroresForm.medioPago ? "of-field--error" : ""}`}>
                  <div className="of-row">
                    <div className="of-field">
                      <label>Monto {medioPago || "medio 1"}</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        value={montoPago1Raw}
                        onChange={(e) => setMontoPago1Raw?.(e.target.value.replace(/[^\d.,]/g, ""))}
                        placeholder="Ej: 10000"
                      />
                      <label className="of-mini-check">
                        <input
                          type="checkbox"
                          checked={pago1Pagado}
                          onChange={(e) => setPago1Pagado?.(e.target.checked)}
                        />
                        Pagado
                      </label>
                    </div>
                    <div className="of-field">
                      <label>Segundo medio</label>
                      <select
                        value={medioPago2}
                        onChange={(e) => setMedioPago2?.(e.target.value)}
                      >
                        <option value="">Seleccionar...</option>
                        <option value="Efectivo">Efectivo</option>
                        <option value="Transferencia">Transferencia</option>
                        <option value="Tarjeta">Tarjeta</option>
                      </select>
                      <label className="of-mini-check">
                        <input
                          type="checkbox"
                          checked={pago2Pagado}
                          onChange={(e) => setPago2Pagado?.(e.target.checked)}
                        />
                        Pagado
                      </label>
                    </div>
                  </div>
                  <div className="of-split-pay__saldo">
                    Saldo segundo medio: <strong>{fmtCLP(saldo)}</strong>
                  </div>
                  {medioPago && medioPago2 && medioPago === medioPago2 && (
                    <span className="of-field__error">Usa dos medios distintos</span>
                  )}
                  {montoPago1Raw && (monto1 <= 0 || monto1 >= Number(totalFinal || 0)) && (
                    <span className="of-field__error">El monto debe ser mayor a 0 y menor que el total</span>
                  )}
                </div>
              )}

              {!trabajador && !dividirPago && <div className="of-toggle-row">
                <span className="of-toggle-row__label">Pagado</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={pagado}
                    onChange={(e) => setPagado(e.target.checked)}
                  />
                  <span className="slider" />
                </label>
              </div>}
            </div>
          </div>

          {/* ===== Sección: Observación ===== */}
          <div className="of-section">
            <div className="of-section__head">
              <div className="of-section__icon">📝</div>
              <h3 className="of-section__title">Observación</h3>
            </div>
            <div className="of-field">
              <textarea
                rows={2}
                value={observacion}
                onChange={(e) => setObservacion(e.target.value)}
                placeholder="Ej: sin palta / entregar en portón"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
